module.exports = __webpack_public_path__ + "img/gallery-image-01.07ec93fc.png";